import {
  Firestore,
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  getFirestore,
  setDoc,
  updateDoc
} from "firebase/firestore";
import { db } from "utils";

/** --------------------------------------------Delete Document--------------------------------------------------- */

const deleteDocument = async (payload: { coll: string; docId: string }) => {
  const { coll, docId } = payload;
  await deleteDoc(doc(db, coll, docId));

  // Delete subcollections recursively
  // await deleteSubcollections(db, coll, docId);
  return;
};

/** -------------------------------------------Delete Document's Sub-collections---------------------------------------------------- */

// const deleteSubcollections = async (db: Firestore, collectionPath: string, documentId: string) => {
//   const subcollections = await getSubcollections(db, collectionPath, documentId);

//   // Iterate over subcollections and delete all documents in each subcollection
//   for (const subcollection of subcollections) {
//     await deleteDocumentsInSubcollection(db, `${collectionPath}/${documentId}/${subcollection}`);
//   }
// };

// const getSubcollections = async (db: any, collectionPath: string, documentId: string) => {
//   const subcollections: string[] = [];
//   const querySnapshot = await getDocs(collection(db, `${collectionPath}/${documentId}/`));
//   querySnapshot.forEach(doc => {
//     subcollections.push(doc.id);
//   });
//   return subcollections;
// };

// const deleteDocumentsInSubcollection = async (db: any, subcollectionPath: string) => {
//   const querySnapshot = await getDocs(collection(db, subcollectionPath));
//   querySnapshot.forEach(async doc => {
//     await deleteDoc(doc.ref);
//   });
// };

/** ----------------------------------------------------------------------------------------------- */

const addDocument = async (payload: { coll: string; data: any }) => {
  const { coll, data } = payload;

  const docRef = await addDoc(collection(db, coll), data);
  return docRef.id;
};

/** ----------------------------------------------------------------------------------------------- */

const setDocument = async (payload: { coll: string; docId: string; data: any; merge?: boolean }) => {
  const { coll, docId, data } = payload;

  const docRef = doc(db, coll, docId);
  if (payload?.merge) await setDoc(docRef, data, { merge: true });
  else {
    await setDoc(docRef, data);
  }
};

/** ----------------------------------------------------------------------------------------------- */

const updateDocument = async (payload: { coll: string; docId: string; data: any }) => {
  const { coll, docId, data } = payload;

  const docRef = doc(db, coll, docId);

  await updateDoc(docRef, data);
};

/** ----------------------------------------------------------------------------------------------- */

const getDocument = async (payload: { coll: string; docId: string }) => {
  const { coll, docId } = payload;

  const docRef = doc(db, coll, docId);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return {
      exists: true,
      data: docSnap.data()
    };
  } else {
    console.log("No such document!");
    return {
      exists: false,
      data: {}
    };
  }
};

/** -------------------------------------------Copy Sub-collection data from one document to another------------------------------------------------------- */

async function copySubcollection(
  sourceDocumentPath: string,
  destinationDocumentPath: string,
  subcollectionName: string
): Promise<void> {
  const firestore: Firestore = getFirestore();

  try {
    // Get the source subcollection data
    const sourceSubcollectionSnapshot = await getDocs(
      collection(firestore, `${sourceDocumentPath}/${subcollectionName}`)
    );

    // Iterate through each document in the source subcollection
    await Promise.all(
      sourceSubcollectionSnapshot.docs.map(async doc => {
        const data = doc.data();
        // Add each document in the source subcollection to the new subcollection in the destination document
        await addDoc(collection(firestore, `${destinationDocumentPath}/${subcollectionName}`), data);
      })
    );

    console.log("Subcollection copied successfully.");
  } catch (error) {
    console.error("Error copying subcollection:", error);
  }
}

/** -------------------------------------Update UID in subcollection---------------------------------------------------------- */

async function updateUidInSubcollection(collectionPath: string, uid: string): Promise<void> {
  const firestore: Firestore = getFirestore();

  try {
    // Get the documents in the subcollection
    const subcollectionSnapshot = await getDocs(collection(firestore, collectionPath));

    // Iterate through each document in the subcollection
    await Promise.all(
      subcollectionSnapshot.docs.map(async doc => {
        // Update the uid field of each document to "hello"
        await updateDoc(doc.ref, { uid });
      })
    );

    console.log("UID updated successfully in subcollection.");
  } catch (error) {
    console.error("Error updating UID in subcollection:", error);
  }
}

export const FirestoreService = {
  addDocument,
  setDocument,
  updateDocument,
  deleteDocument,
  getDocument,
  copySubcollection,
  updateUidInSubcollection
};
